import vuexI18n from 'vuex-i18n'

export default (vue, store, translations, lang) => {
    vue.use(vuexI18n.plugin, store)
    vue.i18n.add(lang, translations)
    vue.i18n.set(lang)
}


// WEBPACK FOOTER //
// ./src/i18n/index.js